module.exports = __webpack_public_path__ + "static/media/CVR_Dao.ca989913.svg";